import { useReducer,useState } from "react";
import "./App.css";

const initialState = {
  email: "",
  password: "",
};

//should have the cases "email", "password", and "reset", along with the default case.
//The default case within reducer function should throw an error with message "invalid action type"
const reducer = (state,{type,payload}) => {

  switch (type) {

    case "email": {
    
      return {
        ...state,
        email: payload,
      }
    }
    case "password": {
      return {
        ...state,
        password: payload,
      }
     
    }

    case "reset": {
      return {
        ...initialState
      }}

    default:
      throw Error(`invalid action type`);
  }
};

function App() {
  // import and use the useReducer hook here, with the reducer function and the initialState.
  const [state, dispatch] = useReducer(reducer,initialState);
  const { email, password } = state;
  //store the data in this object variable when you click on the submit button, to render, the data in the UI.
  const [submittedData, setSubmittedData] = useState({});
 

  // my css style code 
  const [isFocused, setIsFocused] = useState(false);
  const [isValid, setIsValid] = useState(false);

  const handleFocus = () => {
    setIsFocused(true);
  };

  const handleBlur = () => {
    setIsFocused(false);
  };


 // my css style code 


  const handleSubmit=(e)=>{
    e.preventDefault();
    setSubmittedData(state);
    dispatch({ type: "reset" });

  }


  return (

    <div className="App">
          <div className="body">
          <div className="login_box">
          <h2 >useReducer Hook</h2>
      <form className="form-wrapper" data-testid="form-wrapper" onSubmit={handleSubmit} >
        <div className={`useremail-wrapper user_box ${isFocused||isValid?"active":""}`}>
          <label>User Email</label>
          <input type="email" data-testid="user-email" 
           value={email}
           onChange={(e) => {
            setIsValid(e.target.validity.valid);

          dispatch({ type:"email",payload:e.target.value });
        }}
        name="email"
        onFocus={handleFocus}
        onBlur={handleBlur}
      
          required
          />
        </div>
        <div className={`userpassword-wrapper user_box ${isFocused || isValid ? "active":""}`}>
          <label>User Password</label>
          <input type="password" data-testid="user-password"
           value={password}
           onChange={(e) => {
            setIsValid(e.target.validity.valid);
           dispatch({ type: "password", payload: e.target.value });
         }}
         name="password"
         onFocus={handleFocus}
        onBlur={handleBlur}
         required
         />
        </div>
      
          <button type="submit">
          <span></span>
          <span></span>
          <span></span>
          <span></span> 
          Submit
        </button>
      
      </form>

      {/* If there is data in the submittedData variable after submitting the form, show the below div by updating it else show the No details found div. */}
      
      {submittedData.email && submittedData.password ? (
      <div style={{margin:"60px", color:"#03e9f4"}}>
        <div data-testid="submitted-data-email" >User Email:{submittedData.email}</div>
        <div data-testid="submitted-data-password" >User Password:{submittedData.password}</div>
      </div>
   ) : (
      <div data-testid="no-details-container" style={{margin:"60px", color:"#03e9f4"}}>no details found</div>   
      )
      }
    </div>
          </div>
      
        </div>
      
  );
}

// DO NOT change/modify the exports
export default App;
export { reducer, initialState };
